/**
 * 二手车列表
 * http://mockjs.com/
url： https://testzsqy.cheanjia.com/?mock=1#/sms/4
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 二手车列表+get
// 接口地址 /api/v1/used_car/tickets
Mock.mock(/used_car\/tickets/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'page': 1,
    'count': 10,
    'total_count': 99,
    'tickets|10': [{
      'id|+1': 1,
      'created_at': '2017-12-12 12:12',
      'updated_at': '2017-12-12 12:12',
      'status': 1,
      'status_code': 'created',
      'status_name': '待评估',
      'model': '车型车型车型车型车型车型车型',
      'owner_name': '车主姓名',
      'brand_url': 'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg',
      'close_desc': '15天自动关闭'
    }]
  }
})
